import { Component, OnInit } from "@angular/core";
import { merge, Observable, of as observableOf, Subscription } from "rxjs";
import {
  startWith,
  switchMap,
  map,
  catchError,
  finalize,
} from "rxjs/operators";
import { NewDashboardDirectionService } from 'src/app/new-dashboard/core/service/new-dashboard-direction.service';
import { PageDashboardDossierCredit } from "src/app/new-dashboard/core/model/PageDashboardDossierCredit";

@Component({
  selector: "app-juridique-dossiers-list",
  templateUrl: "./dossiers-list.component.html",
  styleUrls: ["./dossiers-list.component.scss"]
})
export class DossiersListComponent implements OnInit {
  isLoading$: Observable<boolean>;
  tab: string = "";
  label: string = "";
  subscription!: Subscription;
  //Loader par cardView
  isLoading: boolean = false;
  pageSize: number = 10; // Number of items to display per page
  pageIndex: number = 0; // Number of
  paginatedItems: PageDashboardDossierCredit;

  filter: string;
  codeDirection: string = "DIRECTION_JURIDIQUE";

  constructor(private _dashboardDirectionService: NewDashboardDirectionService) {}

  ngOnInit() {
    this.getDossiersCreditStatus("", 0);
  }

  getDossiersCreditStatus(filter: string, page: number): void {
    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoading = true;
          const actualFilter = filter !== undefined ? filter : "";
          return this._dashboardDirectionService.getDossiersDirectionStatus(
            this.codeDirection,
            actualFilter,
            page,
            this.pageSize
          );
        }),
        map((data: PageDashboardDossierCredit) => {
          return data;
        }),
        catchError(() => observableOf(null)),
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(data => {
        this.paginatedItems = data;
      });
  }

  goToPage(page: number) {
    if (page >= 0) {
      this.pageIndex = page;
      this.getDossiersCreditStatus(this.filter, page);
    }
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filter = filterValue.trim().toLowerCase();
    this.pageIndex = 0; // Number of
    this.getDossiersCreditStatus(this.filter, this.pageIndex);
  }
  pageSizeChanged() {
    this.pageIndex = 0; // Number of
    this.getDossiersCreditStatus(this.filter, this.pageIndex);
  }
}
